import React, { useCallback, useEffect } from "react";

import EnvService from "../../../services/env.service";
import RequestService from "../../../services/request.service";
import UrlService from "../../../services/url.service";

import LoadingPage from "../../../components/LoadingPage";

const LOGIN_GOV_ENDPOINT = "login/gov";

function LoginGov() {
  const callServiceLoginGov = useCallback(async () => {
    console.log("Iniciando login");
    const { REACT_APP_GRAFENO_ROUTE_URL } = EnvService.getEnv();
    try {
      console.log(
        "Variavel REACT_APP_GRAFENO_ROUTE_URL" + REACT_APP_GRAFENO_ROUTE_URL,
      );
      const redirect = UrlService.getQueryString("redirect_app_url");
      const type = UrlService.getQueryString("type");

      const params = [];

      if (type !== undefined && type !== null && type !== "") {
        params.push(`type=${type}`);
      }

      if (redirect !== undefined && redirect !== null && redirect !== "") {
        params.push(`redirect_app_url=${redirect}`);
      }

      const queryString = params.length ? `?${params.join("&")}` : "";

      await RequestService.post(
        `${REACT_APP_GRAFENO_ROUTE_URL}/${LOGIN_GOV_ENDPOINT}${queryString}`,
      );

      console.log("Redirect to ", redirect);
      window.location = redirect;
    } catch (e) {
      console.error(e);
    }
  }, []);

  const loadUserGcs = useCallback(async () => {
    try {
      callServiceLoginGov();
    } catch (e) {
      console.error(e);
    }
  }, [callServiceLoginGov]);

  useEffect(loadUserGcs, [loadUserGcs]);

  return <LoadingPage />;
}

export default LoginGov;
